export default __webpack_public_path__ + "static/media/1.c932f5be.png";